
import { Vue } from "vue-class-component";

export default class Plane extends Vue {}
